import { render, staticRenderFns } from "./PastasDeArquivos.vue?vue&type=template&id=efdb2516&scoped=true"
import script from "./PastasDeArquivos.vue?vue&type=script&lang=js"
export * from "./PastasDeArquivos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efdb2516",
  null
  
)

export default component.exports